import React from 'react'
import { Icon } from '@mui/material'

export const BaseIcon = ({icon,fontSize,size,...props}) => {
    return (
        <Icon style={{ textAlign: 'center' }} fontSize={size || 'medium'} sx={{ height: size, width: size , ...props }}>
            <img style={{ height: '100%',width:'100%' }} src={icon} />
        </Icon>
    )
}
